import theme from "@/theme";
import { SxProps, Theme } from "@mui/material/styles";

type Styles = {
  formRoot: SxProps<Theme>;
  sectionHeader: SxProps<Theme>;
  sectionHeaderText: SxProps<Theme>;
  inputsBlock: SxProps<Theme>;
  inputGroup: SxProps<Theme>;
  label: SxProps<Theme>;
  input: SxProps<Theme>;
  endAdornment: SxProps<Theme>;
  iconButton: SxProps<Theme>;
  Link: SxProps<Theme>;
};

export const styles: Styles = {
  formRoot: {
    backgroundColor: "white",
    padding: "1.25rem 0",
    borderBottomLeftRadius: "1rem",
    borderBottomRightRadius: "1rem",
    display: "flex",
    flexDirection: "column",
    gap: "28px",
  },

  sectionHeader: {
    height: "48px",
    display: "flex",
    alignItems: "center",
    gap: "12px",
    px: "16px",
    py: "12px",
  },

  sectionHeaderText: {
    fontFamily: "Inter, sans-serif",
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: 0,
    color: "#7D8690",
  },

  inputsBlock: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    px: "16px",
  },

  inputGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },

  label: {
    fontFamily: "Inter, sans-serif",
    fontWeight: 500,
    fontSize: "15px",
    lineHeight: "24px",
    letterSpacing: 0,
    color: "#2A2D31",
  },

  input: {
    width: "100%",
    height: "50px",
    borderRadius: "999px",
    "& .MuiOutlinedInput-notchedOutline": { borderColor: "#E4E7E9" },
    "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#C6CACE" },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.custom.mainBlue,
      borderWidth: "1px",
    },

    "& .MuiInputBase-input::placeholder": {
      fontFamily: "Inter, sans-serif",
      fontWeight: 500,
      fontSize: "15px",
      lineHeight: "20px",
      letterSpacing: "-0.02em",
      color: "#C6CACE",
      opacity: 1,
    },
    "& .MuiInputBase-input": {
      fontFamily: "Inter, sans-serif",
      fontWeight: 500,
      fontSize: "15px",
      lineHeight: "20px",
      letterSpacing: "-0.02em",
      color: "#383C40",
      padding: "12px 16px",
      "&:-webkit-autofill, &:-webkit-autofill:hover, &:-webkit-autofill:focus": {
        WebkitBoxShadow: "0 0 0 1000px #FFFFFF inset",
        WebkitTextFillColor: "#383C40",
        transition: "background-color 5000s ease-in-out 0s",
      },
    },
  },

  endAdornment: {
    "& svg": {
      display: "block",
      width: 25,
      height: 25,
    },
  },

  iconButton: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    lineHeight: 0,
  },

  Link: {
    fontFamily: "Inter, sans-serif",
    fontWeight: 600,
    fontSize: "13px",
    lineHeight: "18px",
    letterSpacing: "0%",
    textDecoration: "underline",
    textDecorationColor: theme.palette.custom.mainBlue,
    textDecorationThickness: "1px",
    textUnderlineOffset: "3px",
    cursor: "pointer",
  },
};
